// extracted by mini-css-extract-plugin
module.exports = {"playbackRateControl":"PlaybackRateControl_playbackRateControl__256Zg","controls":"PlaybackRateControl_controls__1LK_S"};